export default {"src":"/_next/static/media/edit-pencil.3020502a.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};